(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["early-access-price"] && !Shopify.designMode) return;
  try {
    (() => {
    const blockSelector = '[data-early-access-price-block]';

    function getVariantMap(block) {
      const map = new Map();

      block.querySelectorAll('[data-early-access-variant]').forEach((item) => {
        const id = String(item.dataset.variantId || '');
        const price = item.dataset.price || '';
        const isSale = item.dataset.isSale === 'true';

        if (id && price) {
          map.set(id, {
            price,
            isSale
          });
        }
      });

      return map;
    }

    function getScope(block) {
      return (
        block.closest('product-information') ||
        block.closest('[id^="shopify-section-"]') ||
        document
      );
    }

    function getSelectedVariantId(block, variantMap) {
      const scope = getScope(block);

      const inputs = scope.querySelectorAll(
        'form[action*="/cart/add"] input[name="id"], input[name="id"]'
      );

      for (const input of inputs) {
        const id = String(input.value || '');

        if (variantMap.has(id)) {
          return id;
        }
      }

      const urlVariant = new URL(window.location.href).searchParams.get('variant');

      if (urlVariant && variantMap.has(String(urlVariant))) {
        return String(urlVariant);
      }

      const currentVariant = String(block.dataset.currentVariantId || '');

      if (variantMap.has(currentVariant)) {
        return currentVariant;
      }

      return '';
    }

    function updateBlock(block, forcedVariantId = null) {
      const output = block.querySelector('[data-early-access-output]');

      if (!output) return;

      const variantMap = getVariantMap(block);

      let variantId = forcedVariantId
        ? String(forcedVariantId)
        : getSelectedVariantId(block, variantMap);

      if (!variantMap.has(variantId)) {
        variantId = getSelectedVariantId(block, variantMap);
      }

      const variant = variantMap.get(variantId);

      if (!variant) {
        block.hidden = true;
        return;
      }

      block.dataset.currentVariantId = variantId;

      if (!variant.isSale) {
        block.hidden = true;
        return;
      }

      block.hidden = false;
      output.textContent = variant.price;
    }

    function updateAll(forcedVariantId = null) {
      document.querySelectorAll(blockSelector).forEach((block) => {
        updateBlock(block, forcedVariantId);
      });
    }

    function getVariantIdFromEvent(event) {
      const detail = event.detail;

      if (!detail) return null;

      if (detail.variant?.id) {
        return detail.variant.id;
      }

      if (detail.resource?.id) {
        return detail.resource.id;
      }

      if (detail.id) {
        return detail.id;
      }

      return null;
    }

    function scheduleUpdate(forcedVariantId = null) {
      requestAnimationFrame(() => {
        updateAll(forcedVariantId);

        setTimeout(() => {
          updateAll(forcedVariantId);
        }, 50);

        setTimeout(() => {
          updateAll(forcedVariantId);
        }, 150);
      });
    }

    document.addEventListener(
      'change',
      () => {
        scheduleUpdate();
      },
      true
    );

    document.addEventListener(
      'input',
      () => {
        scheduleUpdate();
      },
      true
    );

    document.addEventListener('variant:change', (event) => {
      scheduleUpdate(getVariantIdFromEvent(event));
    });

    document.addEventListener('variant:update', (event) => {
      scheduleUpdate(getVariantIdFromEvent(event));
    });

    document.addEventListener('product:variant-change', (event) => {
      scheduleUpdate(getVariantIdFromEvent(event));
    });

    document.addEventListener('shopify:section:load', () => {
      scheduleUpdate();
    });

    document.addEventListener('shopify:block:select', () => {
      scheduleUpdate();
    });

    function init() {
      updateAll();

      const observer = new MutationObserver((mutations) => {
        const relevantChange = mutations.some((mutation) => {
          return Array.from(mutation.addedNodes).some((node) => {
            if (node.nodeType !== 1) return false;

            return (
              node.matches?.(blockSelector) ||
              node.querySelector?.(blockSelector) ||
              node.matches?.('input[name="id"]') ||
              node.querySelector?.('input[name="id"]')
            );
          });
        });

        if (relevantChange) {
          scheduleUpdate();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
